import { render, staticRenderFns } from "./UserAuthorDataUnitAgent.vue?vue&type=template&id=cd78d6ec&scoped=true&"
import script from "./UserAuthorDataUnitAgent.vue?vue&type=script&lang=ts&"
export * from "./UserAuthorDataUnitAgent.vue?vue&type=script&lang=ts&"
import style0 from "./UserAuthorDataUnitAgent.vue?vue&type=style&index=0&id=cd78d6ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd78d6ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
installComponents(component, {VAvatar})
